// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__1HAcP","rowsWrapper":"style_rowsWrapper__xT4pV","rowWrapper":"style_rowWrapper__YZHBG","text":"style_text__1wbPx"};